import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSplitData } from "pages/editTranscript/util/editor";

// OBSOLETE
export const setTranscriptData = (state, action) => {
  state.transcripts = action.payload.transcripts;
};

// OBSOLETE
export const appendTranscriptData = (state, action) => {
  state.transcripts = state.transcripts.concat(action.payload);
};

// OBSOLETE
export const toggleStrike = (state, action) => {
  let { startIndex, endIndex, snippetId, is_removed } = action.payload;
  const index = state.transcripts.findIndex((t) => t.id === snippetId);

  if (index > -1) {
    const words = state.transcripts[index].children[0].children;

    // text selection was backwards, swap the indexes
    if (startIndex > endIndex) {
      [startIndex, endIndex] = [endIndex, startIndex];
    }

    for (let i = startIndex; i <= endIndex; i++) {
      words[i].is_removed = is_removed;
    }

    state.transcripts[index].children[0].children = words;
    state.hasUnsavedChanges = true;
  }
};

// OBSOLETE
export const changeSpeaker = (state, action) => {
  const { snippetId, speaker } = action.payload;
  const transcripts = [...state.transcripts];

  transcripts.find((t) => t.id === snippetId).speaker = speaker;
  state.hasUnsavedChanges = true;
};

// OBSOLETE
export const rotateSpeaker = (state, action) => {
  const snippetId = action.payload;
  const speakers = state.speakerNames;
  const currentSpeaker = state.transcripts.find((t) => t.id === snippetId).speaker;
  const currentIndex = speakers.indexOf(currentSpeaker);
  const nextIndex = (currentIndex === (speakers.length - 1)) ? 0 : currentIndex + 1;

  state.transcripts.find((t) => t.id === snippetId).speaker = speakers[nextIndex];
  state.hasUnsavedChanges = true;
};

export const split = (state, action) => {
  const { offset, snippetIndex, splitIndex } = action.payload;
  const splitSnippets = getSplitData(state.transcripts, snippetIndex, splitIndex, offset);

  state.transcripts[snippetIndex] = splitSnippets[0];
  state.transcripts.splice(snippetIndex + 1, 0, splitSnippets[1]);

  state.hasUnsavedChanges = true;
};

export const merge = (state, action) => {
  const { snippetIndex, withNext } = action.payload;
  const startIndex = withNext ? snippetIndex : (snippetIndex - 1);

  if (snippetIndex === 0 && !withNext) {
    return false;
  }

  if (snippetIndex === (state.transcripts.length - 1) && withNext) {
    return false;
  }

  const firstSnippet = state.transcripts[startIndex]; //current paragraph
  const secondSnippet = state.transcripts[startIndex + 1]; // next paragraph
  const firstWordsLength = firstSnippet.children[0].children.length;

  const mergedSnippet = {
    ...firstSnippet,
    children: [{
      type: "paragraph",
      snippetId: firstSnippet.id,
      children: firstSnippet.children[0].children.concat(
        secondSnippet.children[0].children.map((word, index) => {
          word.id = firstWordsLength + index;
          word.snippetId = firstSnippet.id;

          return word;
        })
      )
    }],
  };

  state.transcripts.splice(startIndex, 2, mergedSnippet);

  state.hasUnsavedChanges = true;
};

const escapeRegExp = (str) => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};

const replace = ({ target, find, replaceTerm, isCaseSensitive = false }) => {
  const searchTerm = isCaseSensitive ? find : new RegExp(escapeRegExp(find), "ig");

  return target.replace(searchTerm, replaceTerm);
};

export function applySimpleReplace({ find, replaceTerm, isCaseSensitive, replaceAll, transcripts }) {
  const transcriptsLength = transcripts.length;
  const modifiedIndices = [];
  let didBreak = false;

  for (let itemIndex = 0; itemIndex < transcriptsLength; itemIndex++) {
    const text = transcripts[itemIndex].children[0].children
      .map((word) => word.text).join("");

    if (text.toLowerCase().indexOf(find.toLowerCase()) > -1) {
      const wordsLength = transcripts[itemIndex].children[0].children.length;
      let didReplace = false;

      for (let wordIndex = 0; wordIndex < wordsLength; wordIndex++) {
        const word = transcripts[itemIndex].children[0].children[wordIndex].text;

        if (word.toLowerCase().indexOf(find.toLowerCase()) > -1) {
          transcripts[itemIndex].children[0].children[wordIndex].text = replace({
            target: transcripts[itemIndex].children[0].children[wordIndex].text,
            find,
            replaceTerm,
            isCaseSensitive,
          });

          didReplace = true;

          if (!replaceAll) {
            didBreak = true;
            break;
          }
        }
      }

      if (didReplace) {
        modifiedIndices.push(itemIndex);
      }

      if (didBreak) {
        break;
      }
    }
  }

  return { transcripts, modifiedIndices, didBreak };
}

export function applyComplexReplace({ find, replaceTerm, isCaseSensitive, replaceAll, transcripts }) {
  const findList = find.split(" ");
  const windowSize = findList.filter((s) => s !== "").length;
  const tCopy = JSON.parse(JSON.stringify(transcripts));
  const transcriptsLength = transcripts.length;
  const modifiedIndices = [];
  let didBreak = false;

  for (let itemIndex = 0; itemIndex < transcriptsLength; itemIndex++) {
    let text = transcripts[itemIndex].children[0].children
      .map((word) => word.text).join("");
    let findTerm = find;

    if (isCaseSensitive === false) {
      text = text.toLowerCase();
      findTerm = findTerm.toLowerCase();
    }

    if (text.indexOf(findTerm) > -1) {
      const words = tCopy[itemIndex].children[0].children;
      const wordsLength = words.length;

      for (let wordIndex = 0; wordIndex < wordsLength; wordIndex++) {
        const slice = words.slice(wordIndex, wordIndex + windowSize);
        const sliceTextArr = slice.map((s) => s.text);
        let slicedText = sliceTextArr.join("");

        if (isCaseSensitive === false) {
          slicedText = slicedText.toLowerCase();
        }

        if (slicedText.indexOf(findTerm) > -1) {
          const updateIndex = wordIndex + windowSize - 1;

          if (updateIndex >= wordsLength) {
            break;
          }

          transcripts[itemIndex].children[0].children[updateIndex].text =
            slicedText.replaceAll(findTerm, replaceTerm);

          for (let i = updateIndex - 1; i > updateIndex - windowSize; i--) {
            transcripts[itemIndex].children[0].children[i].text = "";
          }

          if (!replaceAll) {
            didBreak = true;
            break;
          }
        }
      }

      transcripts[itemIndex].children[0].children =
        transcripts[itemIndex].children[0].children.filter((word) => word.text !== "");

      modifiedIndices.push(itemIndex);
    }

    if (didBreak) {
      break;
    }
  }

  return { transcripts, modifiedIndices, didBreak };
}

export const replaceInSummary = (state, action) => {
  const { find, replaceTerm, isCaseSensitive } = action.payload;

  state.summary = replace({ target: state.summary, find, replaceTerm, isCaseSensitive });
};

export const replaceInChapters = (state, action) => {
  const { find, replaceTerm, isCaseSensitive } = action.payload;

  state.insights = state.insights.map((insight) => {
    return {
      ...insight,
      summary: replace({ target: insight.summary, find, replaceTerm, isCaseSensitive }),
    };
  });
};

export const simpleFind = (_, action) => {
  const { find, isCaseSensitive, editor } = action.payload;
  const transcripts = JSON.parse(JSON.stringify(editor));
  const transcriptsLength = transcripts.length;
  let searchTerm = find;
  let numResults = 0;

  if (!searchTerm.length) {
    return;
  }

  for (let itemIndex = 0; itemIndex < transcriptsLength; itemIndex++) {
    let text = transcripts[itemIndex].children[0].children.map((word) => word.text).join("");

    if (isCaseSensitive === false) {
      searchTerm = searchTerm.toLowerCase();
      text = text.toLowerCase();
    }

    if (text.indexOf(searchTerm) > -1) {
      numResults += text.split(searchTerm).length - 1;
    }
  }

  const event = new CustomEvent("findAndReplace:numResults", {
    detail: { numResults, find, isCaseSensitive },
  });

  window.dispatchEvent(event);
};

export const complexFind = (_, action) => {
  const { find, isCaseSensitive, editor } = action.payload;
  const transcripts = JSON.parse(JSON.stringify(editor)); // all updates happen here
  const transcriptsLength = transcripts.length;
  const searchTerm = isCaseSensitive ? find : find.toLowerCase();
  let numResults = 0;

  // Loop through each paragraph
  for (let itemIndex = 0; itemIndex < transcriptsLength; itemIndex++) {
    let text = transcripts[itemIndex].children[0].children.map((word) => word.text).join("");

    if (isCaseSensitive === false) {
      text = text.toLowerCase();
    }

    // If we find a potential match, let's take a look
    if (text.indexOf(searchTerm) > -1) {
      numResults += text.split(searchTerm).length - 1;
    }
  }

  const event = new CustomEvent("findAndReplace:numResults", {
    detail: { numResults, find, isCaseSensitive },
  });

  window.dispatchEvent(event);
};


export const simpleSearch = createAsyncThunk(
  "editor/simpleSearch",
  async (payload, thunkAPI) => {
    const { find, isCaseSensitive, editor } = payload;
    const transcript = JSON.parse(JSON.stringify(editor));
    const transcriptsLength = transcript.length;
    let searchTerm = find;
    let numResults = 0;

    if (!searchTerm.length) {
      return { numResults, find, isCaseSensitive };
    }

    for (let itemIndex = 0; itemIndex < transcriptsLength; itemIndex++) {
      let text = transcript[itemIndex].children[0].children.map((word) => word.text).join("");

      if (isCaseSensitive === false) {
        searchTerm = searchTerm.toLowerCase();
        text = text.toLowerCase();
      }

      if (text.indexOf(searchTerm) > -1) {
        numResults += text.split(searchTerm).length - 1;
      }
    }

    return { numResults, find, isCaseSensitive };
  }
);

export const complexSearch = createAsyncThunk(
  "editor/complexSearch",
  async (payload, thunkAPI) => {
    const { find, isCaseSensitive, editor } = payload;
    const transcript = JSON.parse(JSON.stringify(editor)); // all updates happen here
    const transcriptsLength = transcript.length;
    const searchTerm = isCaseSensitive ? find : find.toLowerCase();
    let numResults = 0;

    // Loop through each paragraph
    for (let itemIndex = 0; itemIndex < transcriptsLength; itemIndex++) {
      let text = transcript[itemIndex].children[0].children.map((word) => word.text).join("");

      if (isCaseSensitive === false) {
        text = text.toLowerCase();
      }

      // If we find a potential match, let's take a look
      if (text.indexOf(searchTerm) > -1) {
        numResults += text.split(searchTerm).length - 1;
      }
    }

    return { numResults, find, isCaseSensitive };
  },
);
